import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";
import Link from "next/link";
import Image from "next/image";
import { cn } from "@/lib/utils";

type CarouselCardProps = {
  slide: {
    id: string;
    title: string;
    description: string;
    image: string;
    cta: {
      label: string;
      href?: string;
      modal?: {
        id: string;
      };
    };
  };
  className?: string;
  onCtaClick?: (modalId: string) => void;
  isActive?: boolean;
};

const CarouselCard = ({ slide, className, onCtaClick, isActive }: CarouselCardProps) => {
  const [firstWord, ...restOfTitle] = slide.title.split(" ");

  return (
    <Card className={cn("relative h-full w-full select-none rounded", className)}>
      <div className="absolute inset-0 rounded bg-cover bg-center">
        <Image
          src={slide.image}
          alt={slide.title}
          fill
          style={{ objectFit: "cover" }}
          className="rounded"
          priority
        />
      </div>
      <div
        className={cn(
          "relative z-10 flex h-full flex-col justify-between rounded bg-black bg-opacity-50 p-8 transition-opacity duration-1000",
          isActive ? "opacity-100" : "opacity-0",
        )}
      >
        <div className={cn("flex-grow", isActive && "animate-slide-up")}>
          <CardHeader className="mb-6">
            <CardTitle className="text-8xl text-white">
              {firstWord}
              <br />
              {restOfTitle.join(" ")}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <CardDescription className="text-2xl text-white">
              {slide.description}
            </CardDescription>
          </CardContent>
        </div>
        <CardFooter className={cn("mt-auto", isActive && "animate-slide-down")}>
          {slide.cta.modal?.id && onCtaClick ? (
            <button
              className="min-w-96 rounded-full bg-white p-6 text-2xl text-black"
              onClick={() => onCtaClick(slide.cta.modal?.id ?? "")}
            >
              {slide.cta.label}
            </button>
          ) : (
            slide.cta.href && (
              <Link
                href={slide.cta.href}
                rel="noreferrer"
                className="text-primary text-white underline"
              >
                <button className="min-w-96 rounded-full bg-white p-6 text-2xl text-black">
                  {slide.cta.label}
                </button>
              </Link>
            )
          )}
        </CardFooter>
      </div>
    </Card>
  );
};

export default CarouselCard;
